import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LiveBetaBanner from '../components/common/LiveBetaBanner';
import AuthForm from '../components/auth/AuthForm';
import useAuthForm from '../hooks/useAuthForm';

const LoginPage = ({ sessionRef, setAuthResolving, authError }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const form = useAuthForm({
    mode: 'login',
    sessionRef,
    setAuthResolving,
  });
  const { setSuccess } = form;

  useEffect(() => {
    const flash = location.state?.loginFlash;
    if (typeof flash !== 'string' || !flash) return;
    setSuccess(flash);
    navigate('/login', { replace: true, state: {} });
  }, [location.state, navigate, setSuccess]);

  const displayForm = authError
    ? { ...form, error: form.error || authError }
    : form;

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <LiveBetaBanner />
      <div className="flex flex-1 flex-col items-center justify-center p-4">
        <p className="mb-4 text-sm text-text-muted">
          <Link to="/" className="text-primary hover:text-primary-dark underline-offset-4 hover:underline">
            Back to Shuttlr
          </Link>
        </p>
        <AuthForm mode="login" form={displayForm} switchTo="/signup" />
      </div>
    </div>
  );
};

export default LoginPage;
